export default "__VITE_ASSET__7f308e53__"